import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/sharp-solid-svg-icons/faRotateRight';

type StoreDropdownRefreshIconProps = {
  className?: string;
};

export const StoreDropdownRefreshIcon = ({ className }: StoreDropdownRefreshIconProps) => (
  <FontAwesomeIcon className={className} icon={faRotateRight} />
);
